import { Services } from '@sigma-frontend-libs/commons'

import { components, getServiceComponent, routerQueryReplace } from '@/utils'

function renderCardHeader(h, tab) {
  if (this.items.length > 1) {
    return h(
      'div',
      {
        class: 'headline pa-3'
      },
      [ this.getTranslate(`${Services.payments}.tabs.${tab}`) ]
    )
  }
}
function renderCardBody(h, tab) {
  return h(
    components.card,
    {
      props: {
        rounded: true,
        outline: true
      }
    },
    [ h(getServiceComponent(`${tab}/list`)({ isPage: true })) ]
  )
}
function renderCardContentByTab(h, tab) {
  return h(
    'div',
    {
      class: `${Services.payments}-cards__card`
    },
    [
      renderCardHeader.call(this, h, tab),
      renderCardBody.call(this, h, tab)
    ]
  )
}
function renderCards(h) {
  return h(
    'div',
    {
      class: `${Services.payments}-cards`
    },
    [
      this.items.map(tab => {
        return renderCardContentByTab.call(this, h, tab)
      })
    ]
  )
}

function renderTabsHeader(h) {
  return h(
    components['tabs-header'],
    {
      props: {
        value: this.currentTab,
        tabs: this.items.map(key => {
          return {
            key,
            title: this.getTranslate(`${Services.payments}.tabs.${key}`)
          }
        })
      },
      on: {
        input: event => {
          routerQueryReplace({ currentTab: event })
        }
      }
    }
  )
}
function renderContentByTab(h, tab) {
  return h(
    getServiceComponent(`${tab}/list`)({ isPage: true }),
    {
      key: tab,
      scopedSlots: {
        filter: ({ filter }) => {
          return h(
            getServiceComponent(`${tab}/filter`),
            {
              props: { value: filter },
              on: {
                input: event => {
                  filter = event
                }
              }
            }
          )
        }
      }
    }
  )
}
function renderTabsBody(h) {
  return h(
    components.card,
    {
      props: {
        rounded: true,
        outline: true
      }
    },
    [
      h(
        components.tabs,
        {
          props: { value: this.currentTab }
        },
        [
          this.items.map(tab => {
            return renderContentByTab.call(this, h, tab)
          })
        ]
      )
    ]
  )
}
function renderTabs(h) {
  return h(
    'div',
    {
      class: `${Services.payments}-tabs`
    },
    [
      renderTabsHeader.call(this, h),
      renderTabsBody.call(this, h)
    ]
  )
}

export default function(h) {
  if (this.items.length === 1 || this.viewport.size.width > 1920) {
    return renderCards.call(this, h)
  } else {
    return renderTabs.call(this, h)
  }
}
